export default __webpack_public_path__ + "static/media/pickleball-tournament.e5e179eb.jpeg";